import axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import "./ListPermissions.css";
import { useDispatch, useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { sidebarReducer } from "../../Redux/store";
// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";

function ListPermissions() {
  //API related selectors
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;

  //Permission for Roles
  // const Add_Permission = useSelector(
  //   (state) => state.AccessTocken.Add_Permission
  // );
  // const Edit_Permission = useSelector((state) => state.AccessTocken.Edit_Permission);
  // const Delete_Permission = useSelector(
  //   (state) => state.AccessTocken.Delete_Permission
  // );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );

  //spinner for API
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  //Permission data from API
  const [permissionData, setPermissionData] = useState([]);
  const [roleData, setroleData] = useState([]);
  const [count, setCount] = useState(0);

  const [permissionId, setPermissionId] = useState("Mg==");
  const [changeDone, setChangeDone] = useState(0);

  const dispatch = useDispatch();

  //OnLoad API call
  const responseData = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`permission/list/Mg==`, options)
      .then((response) => {
        setCount(response.data.data.count);
        setPermissionData(response.data.data.rows);
        dispatch(sidebarReducer.apiLoad(false));
      })
      .catch((err) => dispatch(sidebarReducer.apiLoad(false)));

    await axios
      .get(`roles/list`, options)
      .then((response) => {
        if (response.status === 200) {
          // let pages = Math.ceil(response.data.data.count / listLimit);
          //  setNoOfPages(pages);

          // setRoleCount(response.data.data.count);
          response.data.data.count === 0
            ? setroleData([])
            : setroleData(response.data.data.rows);
        } else if (response.status !== 200) {
                    dispatch(sidebarReducer.stringUpdate("AppDown"));

        }
      })
      .catch((err) => {
                 dispatch(sidebarReducer.stringUpdate("AppDown"));

      });
  };

  //Loading the page
  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => {};
    // eslint-disable-next-line
  }, []);

  //Changing the roles
  const roleChange = async (value) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`permission/list/${value}`, options)
      .then((response) => {
        setCount(response.data.data.count);
        response.status === 200 &&
          response.data.data.count !== 0 &&
          dispatch(sidebarReducer.apiLoad(false));

        response.data.data.count !== 0
          ? setPermissionData(response.data.data.rows)
          : axios
              .get(`cmsmodule/list/`, options)
              .then((resp) => {
                resp.status === 200 && dispatch(sidebarReducer.apiLoad(false));
                let arr = resp.data.data.rows;
                setPermissionData([]);
                let moduleObj = arr.map((item) => {
                  let obj = {
                    te_roleid: value,
                    te_module_id: item.te_module_id,
                    te_module_name: item.te_module_name,
                    te_has_view: 0,
                    te_has_add: 0,
                    te_has_edit: 0,
                    te_has_delete: 0,
                    te_has_download: 0,
                  };
                  return obj;
                });
                setPermissionData(moduleObj);
              })
              .catch((err) => dispatch(sidebarReducer.stringUpdate("AppDown")));
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //View permission change handler
  function View_changeHandler(check, value, item, i) {
    let obj = permissionData;
    let val = value;
    item.te_has_view = val === "0" ? 1 : 0;
    obj.splice(i, 1, item);
    setPermissionData(obj);
    setChangeDone(changeDone); //V I
    setChangeDone((val) => val + 1);
    // console.log({ check, value, item, i, obj });
    savePermission(item);
  }

  //Add permission change handler
  function Add_changeHandler(check, value, item, i) {
    let obj = permissionData;
    let val = value;
    item.te_has_add = val === "0" ? 1 : 0;
    obj.splice(i, 1, item);
    setPermissionData(obj);
    setChangeDone((val) => val + 1);
    // console.log({ check, value, item, i, obj });
    savePermission(item);
  }

  //Edit permission change handler
  function Edit_changeHandler(check, value, item, i) {
    let obj = permissionData;
    let val = value;
    item.te_has_edit = val === "0" ? 1 : 0;
    obj.splice(i, 1, item);
    setPermissionData(obj);
    setChangeDone((val) => val + 1);
    // console.log({ check, value, item, i, obj });
    savePermission(item);
  }

  //Delete permission change handler
  function Delete_changeHandler(check, value, item, i) {
    let obj = permissionData;
    let val = value;
    item.te_has_delete = val === "0" ? 1 : 0;
    obj.splice(i, 1, item);
    setPermissionData(obj);
    setChangeDone((val) => val + 1);
    // console.log({ check, value, item, i, obj });
    savePermission(item);
  }

  //Download permission change handler
  function Download_changeHandler(check, value, item, i) {
    let obj = permissionData;
    let val = value;
    item.te_has_download = val === "0" ? 1 : 0;
    obj.splice(i, 1, item);
    setPermissionData(obj);
    setChangeDone((val) => val + 1);
    // console.log({ check, value, item, i, obj });
    savePermission(item);
  }

  //save permission API
  const savePermission = (item) => {
    //save the data from UI to object
    let data = {
      roleid: permissionId,
      moduleid: item.te_module_id,
      view: item.te_has_view,
      add: item.te_has_add,
      edit: item.te_has_edit,
      delete: item.te_has_delete,
      download: item.te_has_download,
    };

    //If count is 0 it will create moduels or it will update modules
    count === 0
      ? axios
          .get(`cmsmodule/list/`, options) //call list of cms modules
          .then((cmslist) => {
            let moduleData = cmslist.data.data.rows;
            let addModule = moduleData.map((obj) => {
              if (item.te_module_id === obj.te_module_id) {
                //return the object if the edited object and created object module ID are same
                return data;
              }
              return {
                //Return the object if edited object and created object module IO are not same
                roleid: permissionId,
                moduleid: obj.te_module_id,
                view: 0,
                add: 0,
                edit: 0,
                delete: 0,
                download: 0,
              };
            });

            //create every module by mapping the objects
            addModule.map((data) =>
              axios
                .post(`permission/add`, data, options)
                .then((response) => setCount((num) => num + 1))
                .catch((er) => dispatch(sidebarReducer.stringUpdate("AppDown")))
            );
          })
          .catch((err) => dispatch(sidebarReducer.stringUpdate("AppDown")))
      : axios
          .put(`permission/update/${item.te_permission_id}`, data, options) //update the permissions using update API
          .then((response) => console.log(response))
          .catch((err) => dispatch(sidebarReducer.stringUpdate("AppDown")));
  };

  return (
    <div>
      {View_Permission === 1 ? (
        <div className="container-fluid g-0">
          <div
            className="row g-0 p-0"
            style={{ backgroundColor: "#f2f3f5", height: "60px" }}
          >
            <div className="col-6 p-2 mt-3">
              <h5>
                <strong>Permissions</strong>
              </h5>
            </div>
            <div className="col-6">
              <span className="d-flex flex-row-reverse mt-2">
                <div className="p-2 me-1">
                  <FormControl sx={{ width: "20ch" }}>
                    <InputLabel
                      id="roleId-change"
                      style={{ zIndex: "0" }}
                      size="small"
                    >
                      Roles
                    </InputLabel>
                    <Select
                      labelId="roleId-change"
                      id="demo-simple-select"
                      label="Roles"
                      size="small"
                      value={permissionId}
                      // value={permissionId}
                      onChange={(e) => {
                        roleChange(e.target.value);
                        setPermissionId(e.target.value);
                      }}
                    >
                      {roleData.map((item, i) => (
                        <MenuItem key={i} value={item.te_role_id}>
                          {item.te_role_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </span>
            </div>
          </div>

          <div className="row row2">
            <div className="col-12 p-0 ps-2">
              {apiLoad ? (
                <div
                  style={{
                    height: "80vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="spinnerApi"></div>
                </div>
              ) : (
                <table className="table table-hover">
                  <thead style={{ backgroundColor: "#ecedef" }}>
                    <tr style={{ textAlign: "left" }} e="true">
                      <th className="border"></th>
                      <th className="border">View Permission</th>
                      <th className="border">Add Permission</th>
                      <th className="border">Edit Permission</th>
                      <th className="border">Delete Permission</th>
                      <th className="border">Download Permission</th>
                    </tr>
                  </thead>
                  <tbody className="text-start">
                    {permissionData.length === 0 ? (
                      <tr>
                        <td colSpan={9} className="border text-center mb-0">
                          NO DATA FOUND
                        </td>
                      </tr>
                    ) : (
                      permissionData.map((item, i) => {
                        let str = item.te_module_name;
                        let moduleName =
                          str.charAt(0).toUpperCase() + str.slice(1);
                        return (
                          <tr key={i}>
                            <td className="border">
                              {moduleName}
                              {/* {`${item.te_module_name.chatAt(0).toUpperCase()}
                            ${item.te_module_name.slice(1)}`} */}
                            </td>
                            <td className="border">
                              <input
                                type="checkbox"
                                checked={item.te_has_view === 1 ? true : false}
                                value={item.te_has_view}
                                onChange={(e) =>
                                  View_changeHandler(
                                    e.target.checked,
                                    e.target.value,
                                    item,
                                    i
                                  )
                                }
                              />
                            </td>
                            <td className="border">
                              <input
                                type="checkbox"
                                checked={item.te_has_add === 1 ? true : false}
                                value={item.te_has_add}
                                onChange={(e) =>
                                  Add_changeHandler(
                                    e.target.checked,
                                    e.target.value,
                                    item,
                                    i
                                  )
                                }
                              />
                            </td>
                            <td className="border">
                              <input
                                type="checkbox"
                                checked={item.te_has_edit === 1 ? true : false}
                                value={item.te_has_edit}
                                onChange={(e) =>
                                  Edit_changeHandler(
                                    e.target.checked,
                                    e.target.value,
                                    item,
                                    i
                                  )
                                }
                              />
                            </td>
                            <td className="border">
                              <input
                                type="checkbox"
                                checked={
                                  item.te_has_delete === 1 ? true : false
                                }
                                value={item.te_has_delete}
                                onChange={(e) =>
                                  Delete_changeHandler(
                                    e.target.checked,
                                    e.target.value,
                                    item,
                                    i
                                  )
                                }
                              />
                            </td>
                            <td className="border">
                              <input
                                type="checkbox"
                                checked={
                                  item.te_has_download === 1 ? true : false
                                }
                                value={item.te_has_download}
                                onChange={(e) =>
                                  Download_changeHandler(
                                    e.target.checked,
                                    e.target.value,
                                    item,
                                    i
                                  )
                                }
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {/* <div className="backdrop">
            <Backdrop
              sx={{
                color: "var(--themes-color)",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={apiLoad}
            //onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div> */}
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListPermissions;